/**
 * KiekkoKingi section controller: story-timeline
 * Kept external so the browser can defer and cache this code.
 */
(() => {
  const kkScript = document.currentScript;
  if (!kkScript) return;

  (() => {
        const rootId = kkScript.dataset.rootId;
        const sectionId = kkScript.dataset.sectionId;
        const destroy = (root) => {
          if (!root || typeof root.__kiekkokingiTimelineCleanup !== 'function') return;
          root.__kiekkokingiTimelineCleanup();
          root.__kiekkokingiTimelineCleanup = null;
          root.removeAttribute('data-timeline-scroll-initialized');
        };
  
        const init = (root) => {
          if (!root || root.hasAttribute('data-timeline-scroll-initialized')) return;
  
          const line = root.querySelector('.kk-story-timeline__line');
          const items = Array.from(root.querySelectorAll('.kk-story-timeline__item'));
          if (!line || items.length < 2) return;
  
          root.setAttribute('data-timeline-scroll-initialized', 'true');
  
          const desktop = window.matchMedia('(min-width: 1080px)');
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
          const nodeCenterOffset = 28 + (Number(kkScript.dataset.nodeSize || 14) / 2);
          const cleanup = [];
          let frame = 0;
  
          const reset = () => {
            root.classList.remove('kk-story-timeline--scroll-enhanced');
            root.style.removeProperty('--kk-timeline-scroll-progress');
            items.forEach((item) => item.classList.remove('is-timeline-active'));
          };
  
          const update = () => {
            frame = 0;
            if (!root.isConnected) return;
  
            if (!desktop.matches || reducedMotion.matches || line.offsetHeight <= 0) {
              reset();
              return;
            }
  
            root.classList.add('kk-story-timeline--scroll-enhanced');
  
            const lineRect = line.getBoundingClientRect();
            const triggerY = Math.min(window.innerHeight * .7, window.innerHeight - 96);
            const progress = Math.max(0, Math.min(1, (triggerY - lineRect.top) / lineRect.height));
  
            root.style.setProperty('--kk-timeline-scroll-progress', progress.toFixed(4));
  
            items.forEach((item) => {
              const nodeY = item.getBoundingClientRect().top + nodeCenterOffset;
              item.classList.toggle('is-timeline-active', nodeY <= triggerY + 1);
            });
          };
  
          const requestUpdate = () => {
            if (frame) return;
            frame = window.requestAnimationFrame(update);
          };
  
          const listen = (target, eventName, handler, options) => {
            target.addEventListener(eventName, handler, options);
            cleanup.push(() => target.removeEventListener(eventName, handler, options));
          };
  
          const listenToMedia = (query) => {
            if (typeof query.addEventListener === 'function') {
              query.addEventListener('change', requestUpdate);
              cleanup.push(() => query.removeEventListener('change', requestUpdate));
            } else {
              query.addListener(requestUpdate);
              cleanup.push(() => query.removeListener(requestUpdate));
            }
          };
  
          listen(window, 'scroll', requestUpdate, { passive: true });
          listen(window, 'resize', requestUpdate, { passive: true });
          listen(root, 'load', requestUpdate, true);
          listenToMedia(desktop);
          listenToMedia(reducedMotion);
  
          root.__kiekkokingiTimelineCleanup = () => {
            if (frame) window.cancelAnimationFrame(frame);
            cleanup.forEach((removeListener) => removeListener());
            reset();
          };
  
          requestUpdate();
        };
  
        const onSectionLoad = (event) => {
          if (!event.detail || event.detail.sectionId !== sectionId) return;
          init(event.target.querySelector('[data-kiekkokingi-story-timeline]') || document.getElementById(rootId));
        };
  
        const onSectionUnload = (event) => {
          if (!event.detail || event.detail.sectionId !== sectionId) return;
          destroy(event.target.querySelector('[data-kiekkokingi-story-timeline]') || document.getElementById(rootId));
          document.removeEventListener('shopify:section:load', onSectionLoad);
          document.removeEventListener('shopify:section:unload', onSectionUnload);
        };
  
        init(document.getElementById(rootId));
        document.addEventListener('shopify:section:load', onSectionLoad);
        document.addEventListener('shopify:section:unload', onSectionUnload);
      })();
})();